import { render, staticRenderFns } from "./registeredProductAdd.vue?vue&type=template&id=ae3bed84&"
import script from "./registeredProductAdd.vue?vue&type=script&lang=js&"
export * from "./registeredProductAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports